import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=805b525e&"
import script from "./ImageViewer.vue?vue&type=script&lang=js&"
export * from "./ImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=805b525e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports